<template>
  <el-dialog title="选择方案" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
             :close-on-press-escape="false" width="60%">
    <el-form size="mini" :inline="true" :model="searchForm" ref="searchForm" class="demo-form-inline">
      <el-form-item label="方案名称">
        <el-input size="mini" v-model="searchForm.title" placeholder="请输入方案名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="应用作物">
        <el-input size="mini" v-model="searchForm.searchCrop" placeholder="请输入作物名称" clearable></el-input>
      </el-form-item>
      <!--      <el-form-item label="使用时期">-->
      <!--        <el-input size="mini" v-model="searchForm.searchPeriod" placeholder="请输入时期名称" clearable></el-input>-->
      <!--      </el-form-item>-->
      <el-form-item label="防治对象">
        <el-input size="mini" v-model="searchForm.searchTarget" placeholder="请输入防治对象" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="mini" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table size="small" :data="tableData" border style="width: 100%" highlight-current-row
              v-loading="loading"
              @selection-change="tableCurrentChange">
      <el-table-column type="selection" align="center" width="60"></el-table-column>
      <el-table-column prop="solutionTitle" label="方案标题" min-width="140"
                       header-align="center"></el-table-column>
      <el-table-column prop="cropTxt" label="应用作物" min-width="100" header-align="center"
                       show-overflow-tooltip></el-table-column>
      <el-table-column prop="periodTxt" label="防控时期" min-width="100" header-align="center"
                       show-overflow-tooltip></el-table-column>
      <el-table-column prop="preventionTarget" label="防治对象" min-width="100" header-align="center"
                       show-overflow-tooltip></el-table-column>
      <el-table-column prop="waterConsumption" label="容器水量" width="130px"
                       align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.waterConsumption }}{{ scope.row.unit }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="supplierName" label="创建店铺" width="160px"
                       align="center">

      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalDataNumber"
      ></el-pagination>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="dialogVisible=false">取 消</el-button>
      <el-button size="small" type="primary" @click="onConfigOK">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import CropSolutionApi from '@/api/cropsolution.js'

export default {
  name: 'SolutionChoose',
  data () {
    return {
      loading: true,
      dialogVisible: false,
      excludeIds: [],
      /*搜索参数*/
      searchForm: {
        title: '',
        searchCrop: '',
        searchPeriod: '',
        searchTarget: '',
        itemTypeId: 0
      },
      pageSize: 15,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      tableData: [],
      multipleSelection: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },
    show (excludeIds) {
      this.excludeIds = excludeIds
      this.getSolutionList()
      this.dialogVisible = true
    },
    getSolutionList () {
      let self = this
      let Params = self.searchForm
      Params.pageIndex = self.curPage
      Params.pageSize = self.pageSize
      self.loading = true
      CropSolutionApi.cropSolutionList(Params, true)
        .then(res => {
          self.loading = false
          self.tableData = res.data.records
          self.totalDataNumber = res.data.total
        }).catch(error => {
        self.loading = false
      })
    },
    dialogFormVisible () {
      this.excludeIds = []
      this.tableData = []
    },
    /*选择第几页*/
    handleCurrentChange (val) {
      let self = this
      self.loading = true
      self.curPage = val
      self.getSolutionList()
    },

    /*每页多少条*/
    handleSizeChange (val) {
      this.pageSize = val
      this.getSolutionList()
    },
    /*搜索查询*/
    onSubmit () {
      this.curPage = 1
      this.getData()
    },
    /*监听复选按钮选中事件*/
    tableCurrentChange (val) {
      this.multipleSelection = val
    },
    onConfigOK () {
      this.$emit('onConfigOK', this.multipleSelection)
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/solution/SolutionChoose.vue